import { Box, Button, Flex, Text, ToggleButton } from '@optiaxiom/react';
import { IconBars, IconXmark } from '@optimizely/axiom-icons';

import { styles } from './WorkflowExecutionTopbar.css';

type WorkflowExecutionTopbarProps = {
  onMenuClick?: () => void;
  onClose?: () => void;
  title?: string;
  isMenuOpen?: boolean;
  status?: string;
  startTime?: string;
};

export function WorkflowExecutionTopbar({
  onMenuClick,
  onClose,
  isMenuOpen,
  title = 'Workflow Execution',
  status,
  startTime,
}: WorkflowExecutionTopbarProps) {
  return (
    <Flex className={styles.topbar} flexDirection="row" justifyContent="space-between">
      <Flex alignItems="center" justifyContent="center" gap="24" flexDirection="row">
        <Box>
          <ToggleButton
            onClick={onMenuClick}
            aria-label="Menu"
            size="lg"
            pressed={isMenuOpen}
            appearance="default"
            icon={<IconBars />}
          />
        </Box>
        <Flex alignItems="center" flexDirection="column" gap="4">
          <Text w="full" h="full" size="md" color="fg.default" fontWeight="600">
            {title}
          </Text>
          {status && startTime && (
            <Text fontSize="md" color="fg.secondary">
              {status} • Started {new Date(startTime).toLocaleString()}
            </Text>
          )}
        </Flex>
      </Flex>
      <Flex alignItems="end" justifyContent="center" gap="8" flexDirection="row">
        <Button
          onClick={onClose}
          size="lg"
          appearance="default"
          icon={<IconXmark />}
          aria-label="Close execution portal"
        >
          Close
        </Button>
      </Flex>
    </Flex>
  );
}
